import { render, staticRenderFns } from "./BlockTyping.vue?vue&type=template&id=972adb72&scoped=true"
import script from "./BlockTyping.vue?vue&type=script&lang=js"
export * from "./BlockTyping.vue?vue&type=script&lang=js"
import style0 from "./BlockTyping.vue?vue&type=style&index=0&id=972adb72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972adb72",
  null
  
)

export default component.exports